import { toast } from "react-toastify";
import { store } from "../../../redux/oldStore";
import { ServerResponse } from "../../../utils/Server";
import { IBanner } from "../MobileAppTypes";

/**
 * BannerController - Centralized API handler for mobile app banner operations
 */
export class BannerController {
  static async listBanners(appId: string): Promise<ServerResponse<IBanner[]>> {
    try {
      const response = await store.server.getApi2<IBanner[]>(`/MobileApp/ListBanners/${appId}`);

      if (!response.Success) {
        console.error('Failed to fetch banners:', response.Message);
        toast.error(response.Message || 'Failed to fetch banners');
      }

      return response;
    } catch (error) {
      console.error('Error fetching banners:', error);
      toast.error('Error fetching banners');
      return {
        Success: false,
        LoginRequired: false,
        Message: 'Error fetching banners',
        GoTo: '',
        Value: []
      };
    }
  }

  // SaveBanner/RemoveBanner read FairId server-side, so these use postApi (appends ?f=), not postApi2.
  static async saveBanner(appId: string, banner: IBanner): Promise<ServerResponse<IBanner>> {
    try {
      const response = await store.server.postApi<ServerResponse<IBanner>>(`../MobileApp/SaveBanner/${appId}`, { jsonData: JSON.stringify(banner) });

      if (response.Success) {
        toast.success('Banner saved successfully');
      } else {
        console.error('Failed to save banner:', response.Message);
        toast.error(response.Message || 'Failed to save banner');
      }

      return response;
    } catch (error) {
      console.error('Error saving banner:', error);
      toast.error('Error saving banner');
      return {
        Success: false,
        LoginRequired: false,
        Message: 'Error saving banner',
        GoTo: '',
        Value: {} as IBanner
      };
    }
  }

  static async removeBanner(appId: string, bannerId: string): Promise<ServerResponse<boolean>> {
    try {
      const response = await store.server.postApi<ServerResponse<boolean>>(`../MobileApp/RemoveBanner`, { appId, bannerId });

      if (response.Success) {
        toast.success('Banner removed successfully');
      } else {
        console.error('Failed to remove banner:', response.Message);
        toast.error(response.Message || 'Failed to remove banner');
      }

      return response;
    } catch (error) {
      console.error('Error removing banner:', error);
      toast.error('Error removing banner');
      return {
        Success: false,
        LoginRequired: false,
        Message: 'Error removing banner',
        GoTo: '',
        Value: false
      };
    }
  }
}
